// extracted by mini-css-extract-plugin
export default {"default":"_type-module__default__Fq8cv","vertical":"_type-module__vertical__hvfAI"};